import { CSSProperties, MouseEventHandler, ReactNode, useEffect, useRef, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import { Grid, ListItemIcon, Typography } from "@mui/material";
import { ImgURL } from "../../Url";
import SettingsIcon from "@mui/icons-material/Settings";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DeleteIcon from "@mui/icons-material/Delete";
import SortIcon from "@mui/icons-material/Sort";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CheckIcon from "@mui/icons-material/Check";
import { NestedMenuItem } from "../Tools/NestedMenuOrigin/NestedMenuItem";
import { getIcons, isEmptyObject, outPutShow } from "../Tools/Tools";
import { checkAvailabilityFromCanModify } from "../rcsgrid/createGridTools";
import {
  addressMenu,
  clsbooksGrid,
  defaultMenu,
  gridMenu,
  paramsMenu,
  personPhotoMenu,
  popupMenu,
  reportMenu,
  treeMenu,
} from "./ContextMenuData/ContextMenuTools";
import { HTMLGridPanelElement } from "../../ComponentInterface";

export function GetDisable(id: string, json: { ID: string; Disabled?: string }[], bool: boolean) {
  if (isEmptyObject(json)) return bool;
  return json.reduce((acc, val) => {
    if (val.ID !== id) return acc;
    return val.Disabled === "1";
  }, bool);
}

interface ContextMenuProps {
  for?:
    | "grid"
    | "clsbook"
    | "tree"
    | "params"
    | "addressParams"
    | "reports"
    | "popupmenu"
    | "accountsPlan"
    | "accountsAnalitic"
    | "personsChildren"
    | "personsTable"
    | "paytypes"
    | "distractions"
    | "personsPhoto"
    | "schedule"
    | "organizations"
    | "NFA";
  children: ReactNode;
  getContextMenuFunction?: (handleContextMenu: MouseEventHandler<HTMLElement>) => void;
  Menu?: any;
  data?: any;
  canGroupOrSort?: boolean;
  changeDataOfItem?: any;
  Details?: boolean;
  onMenuItemClick?: any;
  menuHeader?: ReactNode;
  style?: CSSProperties;
  hiddenContextMenuItems?: string[];
}

const gridsContext = [
  "grid",
  "clsbook",
  "accountsAnalitic",
  "accountsPlan",
  "personsChildren",
  "personsTable",
  "paytypes",
  "distractions",
  "schedule",
  "organizations",
  "NFA",
];

const gridMenuJson = {
  Table: [
    // {
    //   Caption: "Копировать запись",
    //   Image: <ContentCopy fontSize="small" />,
    //   Disabled: true,
    // },
    // { доработка на след год
    //   Caption: "Вырезать запись",
    //   Image: <ContentCut fontSize="small" />,
    //   Disabled: true,
    // },
    // {
    //   Caption: "Вставить из буфера",
    //   Image: <ContentPaste fontSize="small" />,
    //   Disabled: true,
    // },
    // { Caption: "Divider" },
    {
      Caption: "Новая запись",
      value: "Insert",
      Image: <PostAddIcon fontSize="small" />,
    },
    {
      Caption: "Удалить запись",
      value: "Delete",
      Image: <DeleteIcon fontSize="small" />,
    },
    { Caption: "Divider" },
    {
      Caption: "Настройки...",
      Image: <SettingsIcon fontSize="small" />,
      value: "Settings",
    },
    { Caption: "Divider", value: "SettingsDivider" },
    { Caption: "Режим просмотра", value: "OnlyViewMode", ShortCutString: "Ctrl + B" },
    // { Caption: "Сохранять отметку", Disabled: true },
  ],
  Header: [
    { Caption: "Divider" },
    {
      Caption: "По возрастанию",
      Image: <SortIcon fontSize="small" />,
      value: "Sort",
    },
    {
      Caption: "По убыванию",
      Image: <SortIcon fontSize="small" style={{ transform: "scale(1,-1)" }} />,
      value: "Sort-",
    },
    {
      Caption: "Снять сортировку",
      value: "ClearSort",
    },
    { Caption: "Divider" },
    {
      Caption: "Группировать по этому полю",
      value: "GroupBy",
      Disabled: false,
    },
    {
      Caption: "Снять группировку по этому полю",
      value: "GroupByTakeOff",
      Disabled: false,
    },
    { Caption: "Область группировки", value: "GroupShow" },
    { Caption: "Расширенная группировка", Disabled: true },
    { Caption: "Поиск по столбцу", value: "searchByColumn" },
  ],
  Grouping: [
    { Caption: "Область группировки", value: "GroupShow" },
    { Caption: "Расширенная группировка", Disabled: true },
  ],
};

const ClassListForGridMain = ["grid-td", "grid-cell-inner", "grid-data"];

const ClassListForGridHead = [
  "column-header-text",
  "grid-column-title",
  "grid-column",
  "column-span",
  "grid-column-img",
];

const ClassListForGridGroup = ["grid-groups-text", "grid-groups"];

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function ContextMenu(props: ContextMenuProps) {
  const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
  const [contextMenuJSX, setContextMenuJSX] = useState<ReactNode>(null);
  const [assMass, setAssMass] = useState(new Map());
  const [anchorElAss, setAnchorElAss] = useState(new Map());
  const parentNameRef = useRef<string>(null);
  const gridRef = useRef<HTMLGridPanelElement>(null);
  const contextMenuBlockRef = useRef<HTMLDivElement>(null);
  const sizeForMenu = {
    itemHeight: 28,
  };

  useEffect(() => {
    props.getContextMenuFunction?.(handleContextMenu);
  }, []);

  const handleContextMenu: MouseEventHandler<HTMLElement> = async (event) => {
    const getParentNameRef = (target) => {
      const element = typeof target?.getAttribute === "function" ? target : target?.parentElement;
      const keyName =
        element?.getAttribute?.("keyname") ??
        element?.firstElementChild?.getAttribute?.("keyname") ??
        element?.closest?.("[keyname]")?.getAttribute("keyname");

      parentNameRef.current = keyName ?? element?.textContent ?? target?.textContent ?? "";
    };

    //тут мы отправляем на отрисовку список, смотря куда тыкнули
    if (!event) return;
    const target = event.target;
    if (target) getParentNameRef(target);
    const items: ReactNode[] = [],
      clickMenu = [],
      buttonsArr = [];
    if (event.stopPropagation) event.stopPropagation();
    const menuForGrid = props.Menu ? props.Menu : gridMenuJson;

    const loadPopupMenu = (out, json) => {
      for (const value of Object.values(json)) {
        if (value && value.Type === "TMenuItem") {
          const outItem = [];
          loadPopupMenu(outItem, value);
          if (outItem.length > 0) {
            out.push({
              Name: value.Name,
              Caption: value.Caption,
              hidden: value.Visible == 0,
              items: outItem,
            });
          } else {
            out.push({
              Name: value.Name,
              Caption: value.Caption,
              hidden: value.Visible == 0,
            });
          }
        }
      }
    };

    const data = {
      event,
      target,
      props,
      clickMenu,
      items,
      buttonsArr,
      menuForGrid,
      CreateMenuItem: createMenuItem,
      AssignMenuItems: assignMenuItems,
      setContextMenu,
      gridRef,
      GetSortButtons: getSortButtons,
      ClassListForGridMain,
      ClassListForGridHead,
      ClassListForGridGroup,
      loadPopupMenu,
    };

    const getContextMenu: Partial<Record<string, (data) => Promise<void>>> = {
      grid: gridMenu,
      clsbook: clsbooksGrid,
      tree: treeMenu,
      params: paramsMenu,
      addressParams: addressMenu,
      reports: reportMenu,
      popupmenu: popupMenu,
      accountsPlan: gridMenu,
      accountsAnalitic: gridMenu,
      personsChildren: gridMenu,
      personsTable: gridMenu,
      paytypes: gridMenu,
      distractions: gridMenu,
      personsPhoto: personPhotoMenu,
      schedule: gridMenu,
      organizations: gridMenu,
      NFA: gridMenu,
    };
    event.preventDefault();
    const createContextMenu = props.for ? getContextMenu[props.for] : undefined;
    if (createContextMenu) await createContextMenu(data);
    await defaultMenu(props.data, items, createMenuItem);
    if (items.length > 0) setContextMenuJSX(items);
    if (!items.length) return;
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null,
    );
  };

  function assignMenuItems(sectionItems, reqestItems, baseItems) {
    const sectItems = props.data ? (props.data[sectionItems] ? props.data[sectionItems] : []) : [];
    return [...sectItems, ...reqestItems, ...baseItems];
  }

  const calcSum = async ({ grid }) => {
    const multiSelect = grid.grid.getMultiSelect(),
      selectedField = grid.grid.getSelectedField(),
      fieldInfo = selectedField ? grid.grid.getFieldInfo(selectedField) : undefined;
    if (!fieldInfo) return;
    const arrOfValues = await Promise.all(
      multiSelect.map(async (val) => await grid.grid.getActiveSource().getFieldText(selectedField, val)),
    );
    const sum = arrOfValues.reduce((acc, val) => {
      const replacedText = val.replaceAll(" ", "").replaceAll(",", ".");
      const numbersAsString = replacedText.match(/(\d+\.?\d*)/g);
      if (!numbersAsString) return acc;
      const [num] = numbersAsString;
      return acc + parseFloat(num);
    }, 0);
    if (sum === 0) return;
    const fieldTitle = fieldInfo.title;
    const formatedSum = String(sum).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    outPutShow(`Сумма по полю "${fieldTitle}": ${formatedSum}`);
  };

  async function gridContextMenuHandler(data) {
    //Обработчик команд для грида
    if (props.for && gridsContext.includes(props.for)) {
      const command = data.value;
      const grid = gridRef.current;
      switch (command) {
        // HEADER
        case "GroupShow": //открыть/закрыть область группировки
          grid.grid.setOptions(2);
          break;
        case "Sort-": //По убыванию
          data.textcomponent.field.sortDirect = "down";
          grid.grid.sortByRecord(data.textcomponent);
          break;
        case "Sort": //По возрастанию
          data.textcomponent.field.sortDirect = "up";
          grid.grid.sortByRecord(data.textcomponent);
          break;
        case "ClearSort":
          grid.grid.sortByRecord(data.textcomponent, true, true);
          break;
        // GRID
        case "OnlyViewMode": {
          if (grid.grid.doccfgid) {
            handleClick(data);
          } else {
            grid.grid.ChangeViewMode();
          }
          break;
        }
        case "Insert":
          grid.grid.insertRecord(true);
          break;
        case "SaveRedactor":
          grid.grid.postExicstedEditRec(true);
          break;
        case "CancelRedactor":
          grid.grid.cancelRecord();
          break;
        case "AddGroup":
          grid.grid.insertRecord(true);
          break;
        case "AddGroupInner":
          grid.grid.insertRecord(true, undefined, { Child: "1" });
          break;
        case "Delete":
          grid.grid.deleteRecord().then(() => {
            grid.grid.refreshSource("!");
          });
          break;
        case "HideColumn":
          grid.grid.hideColumn(data.textcomponent.field);
          break;
        case "searchByColumn":
          setTimeout(() => {
            grid.grid.searchByColumn(undefined, data.textcomponent.field.el);
          }, 1);
          break;
        case "GroupBy": {
          grid.grid.groupByField(data.textcomponent.field);
          break;
        }
        case "GroupByTakeOff": {
          grid.grid.groupByField(data.textcomponent.field, true);
          break;
        }
        case "calc": {
          await calcSum({ grid });
          break;
        }
        default:
          handleClick(data); //переход в функцию от родителя
          break;
      }
    } else {
      if (props.for === "popupmenu") {
        handlePopupClick(data);
      } else {
        handleClick(data);
      }
    }
    setContextMenu(null);
  }

  async function createMenuItem(json) {
    const items: ReactNode[] = [];
    let lastItemWasDivider = false;
    //В цикле создаем кнопки, которые пришли от сервера + стандартные + по пропсам
    for (const [key, value] of Object.entries(json.MenuData)) {
      if (!value) continue;
      if (value.ID) value.IDfix = value.ID;
      const isDivider = value.Caption === "Divider" || value.Caption === "-";
      if (isDivider) {
        if (!lastItemWasDivider && items.length > 0 && shouldShow(value, json.addictionalInfo)) {
          items.push(<Divider key={key} />);
          lastItemWasDivider = true;
        }
        continue;
      }
      if (value.items) {
        const currentValue = value;
        if (currentValue.ImageIndex) currentValue.Image = getIcons(currentValue.ImageIndex);
        if (currentValue.ProgID) currentValue.ID = currentValue.ProgID;
        createMap(value);
        items.push(
          <NestedMenuItem
            key={key}
            style={{ paddingLeft: "26px", height: sizeForMenu.itemHeight, marginLeft: 2 }}
            leftIcon={
              currentValue.Image === undefined ? (
                <div style={{ paddingLeft: "16px" }} />
              ) : (
                ImgURL(currentValue.Image, {
                  height: "16px",
                  width: "16px",
                  marginLeft: -13,
                  marginTop: 3,
                  marginRight: 13,
                })
              )
            }
            label={currentValue.Caption}
            parentMenuOpen={true}
          >
            <Grid
              style={{
                backgroundColor: "#e6e6e6",
                position: "absolute",
                height: "100%",
                width: props.for === "popupmenu" ? "0px" : "46px",
                top: "0px",
              }}
            />
            {await createMenuItem({
              MenuData: currentValue.items,
              addictionalInfo: json.addictionalInfo,
              State: json.State,
            })}
          </NestedMenuItem>,
        );
        lastItemWasDivider = false;
        continue;
      }
      let currentValue = value;
      currentValue = updateValue(currentValue, json.addictionalInfo);
      if (currentValue.ImageIndex) currentValue.Image = getIcons(currentValue.ImageIndex);
      if (currentValue.ProgID) currentValue.ID = currentValue.ProgID;
      if (["Insert", "Delete", "RecordCopy"].includes(currentValue.value)) {
        currentValue = await checkDisableByCanModify(currentValue);
        currentValue = await getSaveOrCancelVal(currentValue);
      }
      const canGroupOrSort = shouldShow(currentValue, json.addictionalInfo);
      let availability = currentValue.Disabled === "1" ? true : currentValue.Disabled || false;
      const state = await json.State;
      availability = state ? GetDisable(currentValue.ID, state, availability) : availability;
      if (canGroupOrSort && !props.hiddenContextMenuItems?.includes(currentValue.value)) {
        items.push(
          <MenuItem
            onClick={() => {
              gridContextMenuHandler({
                ...json.addictionalInfo,
                ...currentValue,
              });
            }}
            style={{ height: sizeForMenu.itemHeight, display: currentValue.hidden ? "none" : "" }}
            disabled={availability}
            value={currentValue.value}
            id={currentValue.ID === undefined ? "" : currentValue.ID}
            status={currentValue.Status === undefined ? "" : currentValue.Status}
            key={key + "contextMenu"}
            {...json.addictionalInfo}
          >
            <ListItemIcon sx={{ display: props.for === "popupmenu" ? "none" : "" }}>
              {(currentValue.Image && currentValue.ID) || currentValue.Status
                ? ImgURL(currentValue.Image, { width: "20px" })
                : null}
              {currentValue.Image && !currentValue.ID && !currentValue.Status ? currentValue.Image : null}
            </ListItemIcon>
            <ListItemText
              inset
              style={{ padding: 0 }}
              value={currentValue.value}
              id={currentValue.ID === undefined ? "" : currentValue.ID}
            >
              {currentValue.Caption}
            </ListItemText>
            <Typography variant="body2" color="text.secondary" sx={{ pl: 1 }}>
              {currentValue.ShortCutString}
            </Typography>
          </MenuItem>,
        );
        lastItemWasDivider = false;
      }
    }
    if (lastItemWasDivider) items.pop();
    return items;
  }

  function getSaveOrCancelVal(currentValue) {
    let returnButton = currentValue;
    if (!gridRef.current) return returnButton;

    const grid = gridRef.current;
    const isEditMode = grid.grid.getActiveSource().isEditModeState();
    const isMultiSelect = grid.grid.getMultiSelect().length > 0;
    let isEditModeText = isEditMode === 1 && "редактирование";
    isEditModeText = isEditMode === 3 ? "вставку" : isEditModeText;
    switch (currentValue.value) {
      case "Insert": {
        if (isEditMode === 0 || isEditMode === 3) {
          returnButton = {
            Caption: `Сохранить ${isEditModeText}`,
            value: "SaveRedactor",
            Image: <SaveAltIcon fontSize="small" />,
            Disabled: currentValue.Disable,
          };
        }

        break;
      }
      case "Delete": {
        if (isEditMode === 0 || isEditMode === 3) {
          returnButton = {
            Caption: `Отменить ${isEditModeText}`,
            value: "CancelRedactor",
            Image: <CancelIcon fontSize="small" />,
            Disabled: currentValue.Disable,
          };
        }

        break;
      }
      case "RecordCopy": {
        if (isMultiSelect) {
          returnButton = {
            Caption: `Создать копии документов`,
            value: "RecordCopy",
            Disabled: currentValue.Disable,
          };
        }
        break;
      }
    }
    return returnButton;
  }

  function checkDisableByCanModify(currentValue) {
    let returnButton = currentValue;
    if (!gridRef.current) return returnButton;

    const grid = gridRef.current;
    const canModifyDelete = checkAvailabilityFromCanModify(2, grid.grid),
      canModifyInsert = checkAvailabilityFromCanModify(0, grid.grid);
    switch (currentValue.value) {
      case "Insert": {
        returnButton = {
          ...currentValue,
          Disabled: currentValue.Disabled ? currentValue.Disabled : canModifyInsert,
        };
        break;
      }
      case "Delete": {
        returnButton = {
          ...currentValue,
          Disabled: currentValue.Disabled ? currentValue.Disabled : canModifyDelete,
        };
        break;
      }
      case "RecordCopy": {
        returnButton = {
          ...currentValue,
          Disabled: currentValue.Disabled ? currentValue.Disabled : canModifyInsert,
        };
        break;
      }
    }
    return returnButton;
  }

  function updateValue(currentValue, addictionalInfo) {
    if (gridRef.current && props.canGroupOrSort === undefined && currentValue.value) {
      const grid = gridRef.current.grid;
      const command = currentValue.value;
      switch (command) {
        case "OnlyViewMode": {
          return {
            ...currentValue,
            Image: gridRef.current.grid.OnlyViewMode ? <CheckIcon fontSize={"small"} /> : null,
          };
        }
        case "calc": {
          const multiSelect = grid.getMultiSelect();
          if (multiSelect.length === 0) return { ...currentValue, hidden: true };
          const selectedField = grid.getSelectedField();
          const fieldInfo = selectedField ? grid.getFieldInfo(selectedField) : undefined;
          if (!fieldInfo) return { ...currentValue, hidden: true };
          if (multiSelect.length > 0)
            return {
              ...currentValue,
              Caption: `Сумма по полям "${fieldInfo.title}"`,
            };

          break;
        }
        default:
          if (props.changeDataOfItem) {
            return {
              ...currentValue,
              ...props.changeDataOfItem(currentValue, addictionalInfo),
            };
          } else {
            return currentValue;
          }
      }
    } else {
      return currentValue;
    }
  }

  function shouldShow(currentValue, addictionalInfo) {
    if (gridRef.current && props.canGroupOrSort === undefined && currentValue.value) {
      let canShow = true;
      if (addictionalInfo && addictionalInfo.textcomponent) {
        const field = addictionalInfo.textcomponent.field;
        if (currentValue.value.includes("GroupBy")) {
          let isFieldGrouped = false;
          canShow = gridRef.current.grid.canGroup(field);
          for (const val of gridRef.current.grid.getGroups()) {
            if (val.fieldName === field.fieldName) isFieldGrouped = true;
          }
          if (canShow) {
            switch (currentValue.value) {
              case "GroupBy":
                if (isFieldGrouped) canShow = false;
                break;
              case "GroupByTakeOff":
                canShow = isFieldGrouped;
                break;
            }
          }
        }

        if (currentValue.value.includes("Sort") && gridRef.current) canShow = gridRef.current.grid.canSort(field);
        if (currentValue.value === "HideColumn" && gridRef.current.grid.detailsInDetail) canShow = false;
      } else {
        switch (currentValue.value) {
          case "Details": {
            if (!props.Details) canShow = false;
            break;
          }
          case "PrintSelectedRecords": {
            if (gridRef.current.grid.getMultiSelect().length === 0) {
              canShow = false;
            }
            break;
          }
          case "Settings": {
            if (!gridRef.current.grid.doccfgid) {
              canShow = false;
            }
            break;
          }
          case "SettingsDivider": {
            if (!gridRef.current.grid.doccfgid) {
              canShow = false;
            }
            break;
          }
        }
      }
      return canShow;
    } else {
      return true;
    }
  }

  function createMap(list) {
    for (const value of Object.values(list)) {
      setAnchorElAss(anchorElAss.set(value.Caption, null));
      setAssMass(assMass.set(value.Caption, false));
    }
  }

  function getSortButtons(sortDirect: string | undefined, arr: unknown[]) {
    switch (sortDirect) {
      case "down":
        arr.splice(2, 1);
        break;

      case "up":
        arr.splice(3, 1);
        break;

      default:
        arr.splice(4, 1);
        break;
    }
  }

  const handlePopupClick = (event) => {
    //обработчик клика на функцию от родителя
    props.onMenuItemClick?.(event, event.Name, null, null, parentNameRef.current);
    setContextMenu(null);
  };

  const handleClick = (event: unknown) => {
    //обработчик клика на функцию от родителя
    props.onMenuItemClick?.(event, gridRef.current);
    setContextMenu(null);
  };

  return (
    <div
      onContextMenu={handleContextMenu}
      style={{ cursor: "context-menu", height: "100%", width: "100%", ...props.style }}
    >
      {props.children}
      <Menu
        open={contextMenu !== null}
        PaperProps={props.menuHeader ? { sx: { overflowY: "hidden" } } : undefined}
        onClose={() => {
          setContextMenu(null);
        }}
        anchorReference="anchorPosition"
        anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
      >
        {props.menuHeader && (
          <div
            style={{ width: 0, minWidth: "100%", maxWidth: "100%", overflow: "hidden" }}
            onClickCapture={() => {
              setContextMenu(null);
            }}
          >
            {props.menuHeader}
          </div>
        )}
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Grid
            style={{
              backgroundColor: "#e6e6e6",
              position: "absolute",
              height: "100%",
              width: props.for === "popupmenu" ? "0px" : "46px",
            }}
          />
          <Grid
            onLoad={() => {
              const parentElement = contextMenuBlockRef.current?.parentElement?.parentElement?.parentElement;
              if (!contextMenuBlockRef.current || !parentElement) return;
              //TODO КОСТЫЛЬ ДЛЯ ФАЕРФОКСА
              if (parentElement.clientHeight < contextMenuBlockRef.current.scrollHeight)
                contextMenuBlockRef.current.style.paddingRight = "15px";
            }}
            ref={contextMenuBlockRef}
          >
            {contextMenuJSX}
          </Grid>
        </Grid>
      </Menu>
    </div>
  );
}
